import { operators as o } from '@pendo/aggregations';
import { DxGroupBy, DXMetadataValue } from '@middleware/types';
import { MetadataTypeId, PageParameterId } from '@middleware/types';

export const regionEvalExpressionForFilter =
    'if(isNull(country)||country==""||isNull(region)||region=="", null, country+"-"+region)';

export const regionEvalExpression = 'if(isNull(country)||country==""||isNull(region)||region=="", "(none)", country+"-"+region)';

export const countryEvalExpressionForFilter = 'if(isNull(country)||country=="", null, country)';

export const countryEvalExpression = 'if(isNull(country)||country=="", "(none)", country)';

export const buildNoneEvalExpression = (field: string) => `if(isNull(${field}), "(none)", ${field})`;

const metadataGroup = (groupByMetadata: DXMetadataValue) =>
    `${groupByMetadata.kind}.${groupByMetadata.group}.${groupByMetadata.field}`;
const metadataGroupAutomatic = (groupByMetadata: DXMetadataValue) => `u.${groupByMetadata.field}`;
const metadataGroupHistorical = (groupByMetadata: DXMetadataValue) =>
    `properties.__sg__.${groupByMetadata.kind.toLowerCase()}metadata.${groupByMetadata.group}__${
        groupByMetadata.field
    }`;
const metadataGroupEvent = (groupByMetadata: DXMetadataValue) => `properties.${groupByMetadata.DisplayName}`;
const metadataGroupUtm = (groupByMetadata: DXMetadataValue) => `properties.__utm__.${groupByMetadata.field}`;

export const groupByConfigs: { [key in MetadataTypeId]: DxGroupBy } = {
    [MetadataTypeId.Automatic]: {
        id: MetadataTypeId.Automatic,
        metadataGroup: metadataGroupAutomatic,
        bulkExpand: null,
        userAgent: o.userAgent('u', 'userAgent'),
        evalExpression: null,
    },
    [MetadataTypeId.Utm]: {
        id: MetadataTypeId.Utm,
        metadataGroup: metadataGroupUtm,
        bulkExpand: null,
        evalExpression: null,
    },
    [MetadataTypeId.PageParameter]: {
        id: MetadataTypeId.PageParameter,
        metadataGroup: () => PageParameterId,
        bulkExpand: null,
        evalExpression: null,
    },
    [MetadataTypeId.EventTopLevel]: {
        id: MetadataTypeId.EventTopLevel,
        metadataGroup: (groupByMetadata: DXMetadataValue) => `${groupByMetadata.field}`,
        bulkExpand: null,
        evalExpression: null,
    },
    [MetadataTypeId.Visitor]: {
        id: MetadataTypeId.Visitor,
        metadataGroup,
        bulkExpand: o.bulkExpand('visitor'),
        evalExpression: null,
    },
    [MetadataTypeId.Account]: {
        id: MetadataTypeId.Account,
        metadataGroup,
        bulkExpand: o.bulkExpand('account'),
        evalExpression: null,
    },
    [MetadataTypeId.ParentAccount]: {
        id: MetadataTypeId.ParentAccount,
        metadataGroup,
        bulkExpand: o.bulkExpand('parentAccount'),
        evalExpression: o.evalExpression({ parentAccountId: 'parentAccountId(accountId)' }),
    },
    [MetadataTypeId.Historical]: {
        id: MetadataTypeId.Historical,
        metadataGroup: metadataGroupHistorical,
        bulkExpand: null,
        evalExpression: null,
        trimExpression: (fieldName) => `if(isString(${fieldName}), trim(trim(${fieldName}, "\\n"), " "), ${fieldName})`,
    },
    [MetadataTypeId.Event]: {
        id: MetadataTypeId.Event,
        metadataGroup: metadataGroupEvent,
        bulkExpand: null,
        evalExpression: null,
        trimExpression: (fieldName) => `if(isString(${fieldName}), trim(trim(${fieldName}, "\\n"), " "), ${fieldName})`,
    },
};

export default groupByConfigs;
